<template>
  <div>
    <div class="rc-title flex-between">
      <div>更多功能</div>
      <div class="back" @click="back">X</div>
    </div>
    <div class="content-wrap">
      <div class="buttonSet">
        <el-button type="primary" @click="jump('/orderManagment')">订单查询</el-button>
        <el-button type="primary" @click="jump('/returnsAndRefunds')" plain>退款退货订单</el-button>
        <el-button type="primary" @click="jump('/shiftChange')" plain>交接班</el-button>
        <!-- <el-button type="primary" plain @click="jump('')">设置</el-button> -->
      </div>
       <div class="confirm">
        <el-button type="primary" @click="dialogVisible = true">退出登录</el-button>
      </div>
    </div>
       <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确定退出用户吗</span>
      <span slot="footer" class="dialog-footer" style="z-index:2100">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="exit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
        dialogVisible:false,
          userList: "",
      shopInformation: "",
    };
  },
  created() {
          let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
  },
  methods: {
        exit() {
      var that = this;
      var userId = this.userList.id; //用户Id
      var sessionId = this.userList.sessionId;
      console.log(userId, sessionId, "sessionId");
      this.request
        .post("qrcapi/Login_loginOut", {
          userId: userId,
          sessionId: sessionId
        })
        .then(function(response) {
          if (response.code == 1) {
            // that.$message({
            //   type: "success",
            //   message: response.msg
            // });
            that.dialogVisible = false;
            that.$router.push("/");
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
          console.log(response);
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    back() {
      this.$router.go(-1);
    },
    jump(adress) {
      this.$router.push({ path: adress });
    }
  }
};
</script>

<style  scoped>
.confirm {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.content-wrap {
  padding: 23px 26px;
  font-size: 14px;
}
.back {
  color: gray;
  font-size: 20px;
  cursor: pointer;
}
.rc-title {
  /* background: #eeeeee; */
   border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderMoreFunction.vue